import { Route, Routes, useLocation } from "react-router-dom"
import "./styles.css"
import Lessons from "./pages/Lessons"
import Players from "./pages/Players"
import Notebook from "./pages/Notebook"
import { modalContext } from "./providers/modal.provider"
import { useContext, useEffect } from "react"
import SModal from "./SModal"
import Profile from "./pages/Profile"
import Landing from "./pages/Landing"
import MobileNav from "./MobileNav"
import Access from "./pages/Access"
import { profileContext } from "./providers/profile.provider"
import EnvironmentBadge from "./atoms/EnvironmentBadge"
import ConnectionBadge from "./atoms/ConnectionBadge"
import { useCalendarRoutine } from "./services/calendarSync.service"
import { rememberPage } from "./utils/feedback.utils"

export default function App() {
	const Modal = useContext(modalContext)
	const { loading, coach, needsRegistration } = useContext(profileContext)
	const location = useLocation()

	// Google Calendar si rimette a posto da solo: quello che senza rete non è
	// arrivato, e il controllo di ogni giorno (services/calendarSync.service.js)
	useCalendarRoutine(coach)

	// Chi segnala un problema dal profilo l'ha visto, di solito, nella
	// pagina di prima: la segnalazione se la porta dietro da sola.
	useEffect(() => {
		rememberPage(location.pathname)
	}, [location.pathname])

	useEffect(() => {
		if (loading) return

		// Autenticato ma senza maestro: la registrazione è da finire, e finché
		// non lo è non c'è niente da guardare. Se il foglio viene chiuso
		// torna, perché l'alternativa è un'app vuota senza spiegazioni.
		if (needsRegistration) {
			if (Modal.type !== "register") Modal.open("register")
			return
		}

		// Chiude il modal quando Firebase conferma il login
		if (coach && (Modal.type === "auth" || Modal.type === "register")) {
			Modal.close()
		}
	}, [loading, coach, needsRegistration, Modal.isOpen])

	// Le pagine dell'app, a chi non è dentro, mostrano l'accesso dell'app e
	// non il sito: sito e app sono due cose (docs/interfaccia.md, "Il sito e
	// l'app"). Finché Firebase non ha risposto si vede l'app che carica, con
	// le lezioni in arrivo: è la schermata di avvio.
	const appShell = !loading && !coach ? <Access /> : <MobileNav />

	return (
		<>
			<EnvironmentBadge />
			<ConnectionBadge />
			<Routes>
				<Route path="/" element={<Landing />} />
				<Route element={appShell}>
					<Route path="lessons" element={<Lessons />} />
					{/* una lezione sola: il link nell'evento del calendario */}
					<Route path="lessons/:lessonID" element={<Lessons />} />
					<Route path="profile" element={<Profile />} />
					<Route path="players" element={<Players />} />
					<Route path="notebook" element={<Notebook />} />
				</Route>
			</Routes>
			<SModal
				isOpen={Modal.isOpen}
				onClose={() => Modal.close()}
				type={Modal.type}
				data={Modal.data}
				step={Modal.step}
				action={Modal.action}
			/>
		</>
	)
}
